import { Component, Input, OnInit } from '@angular/core';
import { LocaleSettingService } from 'app/services/i18n/locale-setting.service';
import { Select } from '@ngxs/store';
import { LenderUserState } from 'app/store/lender-user/lender-user/lender-user.state';
import { Observable, take } from 'rxjs';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'activity-row-deal',
  template: `
    <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
      <mat-icon>attach_money</mat-icon>
    </div>
    <div class="description">
      <strong>Congratulations – Deal Funded! </strong>
      <div class="text">
        <span *ngIf="activity.meta.closedBy && activity.meta.closedBy === lenderUserId">You</span>
        <span *ngIf="activity.meta.closedBy && activity.meta.closedBy !== lenderUserId">{{ activity.meta.lenderUserName }}</span>
        funded a new deal for {{ localeCurrencySymbol }}<span>{{ activity.meta.amount }}</span>
      </div>
    </div>
  `,
  styles: []
})
export class ActivityRowDealComponent implements OnInit {
  @Select(LenderUserState.lenderUser) lenderUser$: Observable<LenderUser>;
  @Input() activity;
  lenderUserId: number;
  localeCurrencySymbol: string | null;

  constructor(
    private localeSettingService: LocaleSettingService,
  ) {}

  ngOnInit () {
    this.lenderUser$.pipe(take(1)).subscribe((currentUser) => {
      this.lenderUserId = currentUser.id;
    });
    this.localeCurrencySymbol = this.localeSettingService.getLocaleCurrencySymbol();
  }
}
